module.exports = __webpack_public_path__ + "img/red2.22fb57af.jpg";